import {MouseEvent, Ref} from 'react';
import {Link, LinkProps, useLocation} from 'react-router-dom';

import {MenuAction} from './MenuAction';

interface MenuLinkProps extends LinkProps {
  variant?: 'light' | 'dark';
  ref?: Ref<HTMLAnchorElement>;
  action?: () => void | Promise<void>;
}

export function MenuLink(props: MenuLinkProps) {
  const {ref} = props;
  const location = useLocation();
  const {variant, ...menuActionProps} = props;

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    const isSamePath = location.pathname === props.to && !props.action;

    if (isSamePath) {
      event.preventDefault();
    }

    if (props.onClick) {
      props.onClick(event);
    }
  };

  return (
    <MenuAction
      as={Link}
      {...menuActionProps}
      ref={ref}
      onClick={handleClick}
      $variant={variant}
      tabIndex={-1}
    />
  );
}
